import { Mapper } from "../../../../base/utils/mapper";

import { ChannelSendModel }
from "../../../../domain/models/configuration/channel-send.model";

import { ChannelSendEntity }
from "../entities/channel-send.entity";

export class ChannelSendImplementationRepositoryMapper
extends Mapper<
ChannelSendEntity,
ChannelSendModel
> {

    mapFrom(param:
    ChannelSendEntity):
    ChannelSendModel {

        return {
            ...param
        };
    }

    mapTo(param:
    ChannelSendModel):
    ChannelSendEntity {

        return {
            ...param
        };
    }
}